import React from 'react';

import PohButton, { ButtonSize, ButtonVariant } from '@ui-kit/Button';

const TopInfoBanner = ({ id, children }: { id: string; children: React.ReactNode }) => {
  const [isClosed, setIsClosed] = React.useState(!!localStorage.getItem(id));
  if (isClosed) return null;
  return (
    <div className="">
      <div className="container border border-info p-1 px-3 bg-info-subtle d-flex justify-content-between align-items-center">
        <div style={{ lineHeight: 1 }}>{children}</div>
        <PohButton
          size={ButtonSize.Small}
          onClick={() => {
            setIsClosed(true);
            localStorage.setItem(id, '1');
          }}
          variant={ButtonVariant.OutlineInfo}
        >
          Понятно
        </PohButton>
      </div>
    </div>
  );
};

export default TopInfoBanner;
